module.exports = __webpack_public_path__ + "img/banco_nacional.14f549f.svg";